// @ts-strict-ignore
import React from "react";
import icons from "../../assets/icons";
import styled from "styled-components";
import { kebabCase } from "lodash";
interface IIcons extends React.HTMLAttributes<HTMLElement> {
  name: string;
  size?: number;
  color?: string;
  isHidden?: boolean;
}

const Icons: React.FC<IIcons> = (props) => {
  const { name, size, color, isHidden } = props;
  const C = Object.prototype.hasOwnProperty.call(icons, name)
    ? icons[name as keyof typeof icons]
    : icons.image;
  return (
    <IconWrap
      $iconSize={size}
      color={color}
      isHidden={isHidden}
      data-id="icon-wrap"
      {...props}
    >
      <C role="img" aria-label={kebabCase(name)} />
    </IconWrap>
  );
};

const IconWrap = styled.div<{
  color?: string;
  $iconSize?: number;
  isHidden?: boolean;
}>`
  margin: 0 5px;
  width: ${({ $iconSize }) => ($iconSize ? `${$iconSize}px` : "16px")};
  height: ${({ $iconSize }) => ($iconSize ? `${$iconSize}px` : "16px")};

  visibility: ${({ isHidden }) => (isHidden ? "hidden" : "visible")};

  svg {
    fill: ${({ color }) => (color ? color : "#454545")};
    width: ${({ $iconSize }) => ($iconSize ? `${$iconSize}px` : "16px")};
    height: ${({ $iconSize }) => ($iconSize ? `${$iconSize}px` : "16px")};
  }
`;
export default Icons;
